var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "show-title": false,
            "show-footer": false,
            "class-name": "filter-name-modal",
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c("div", { staticClass: "filter-name-modal-wrapper" }, [
            _c("div", { staticClass: "filter-name-modal-title" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("edit")]),
              _vm._v(" "),
              _c("span", [_vm._v("Filtre Adı")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-name-modal-content" }, [
              _c("p", [_vm._v("Lütfen filtre için bir isim girin:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localFilterName,
                    expression: "localFilterName",
                  },
                ],
                ref: "filterNameInput",
                staticClass: "filter-name-input-modal",
                attrs: { type: "text", placeholder: "Filtre adını girin" },
                domProps: { value: _vm.localFilterName },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleConfirm.apply(null, arguments)
                  },
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.localFilterName = $event.target.value
                    },
                    _vm.handleInput,
                  ],
                  blur: _vm.handleBlur,
                },
              }),
              _vm._v(" "),
              _vm.error
                ? _c("div", { staticClass: "filter-name-error" }, [
                    _vm._v("\n            " + _vm._s(_vm.error) + "\n        "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.suggestedName && _vm.suggestedName !== _vm.localFilterName
                ? _c("div", { staticClass: "filter-name-info" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Bu isim zaten kullanılıyor. Filtre "),
                      _c("strong", [
                        _vm._v('"' + _vm._s(_vm.suggestedName) + '"'),
                      ]),
                      _vm._v(" olarak oluşturulacak."),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-name-modal-footer" },
                [
                  _c("SupsisButton", { on: { click: _vm.handleCancel } }, [
                    _vm._v("\n                İptal\n            "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        primary: "",
                        disabled:
                          !_vm.localFilterName || !_vm.localFilterName.trim(),
                      },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("\n                Kaydet\n            ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }